export enum FiatCurrencyCode {
  RUB = 'RUB',
  TJS = 'TJS',
  KGS = 'KGS',
  ABH = 'ABH',
  AZN = 'AZN',
}
